import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import OfficeManagement from "./components/OfficeManagement";
import MemberDirectory from "./components/MemberDirectory";
import TaskManagement from "./components/TaskManagement";
import MarketingTemplates from "./components/MarketingTemplates";
import EmployeeResources from "./components/EmployeeResources";
import OccupancyReporting from "./components/OccupancyReporting";
import TermRateReporting from "./components/TermRateReporting";
import Settings from "./components/Settings";
import CRM from "./components/CRM";
import Contacts from "./components/Contacts";
import Companies from "./components/Companies";
import ContactProfilePage from "./components/ContactProfilePage";
import CompanyProfilePage from "./components/CompanyProfilePage";
import DealProfilePage from "./components/DealProfilePage";
import SimpleGmailCallback from "./components/SimpleGmailCallback";

import OfficeProfilePage from "./components/OfficeProfilePage";
import MemberProfilePage from "./components/MemberProfilePage";
import Navigation from "./components/Navigation";
import Header from "./components/Header";

function AuthenticatedApp() {
  const { user } = useAuth();
  const [selectedLocation, setSelectedLocation] = useState(
    user?.primary_location || 'All Locations'
  );

  // Update selected location when user changes
  useEffect(() => {
    if (user?.primary_location) {
      setSelectedLocation(user.primary_location);
    }
  }, [user]);

  const handleLocationChange = (location) => {
    setSelectedLocation(location);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex">
        <Navigation 
          selectedLocation={selectedLocation}
          onLocationChange={handleLocationChange}
          userRole={user?.role}
        />
        <div className="flex-1">
        <Routes>
          <Route path="/" element={<Dashboard selectedLocation={selectedLocation} />} />
          <Route path="/crm/contacts" element={<Contacts selectedLocation={selectedLocation} />} />
          <Route path="/crm/contacts/:id" element={<ContactProfilePage selectedLocation={selectedLocation} />} />
          <Route path="/crm/companies" element={<Companies selectedLocation={selectedLocation} />} />
          <Route path="/crm/companies/:id" element={<CompanyProfilePage selectedLocation={selectedLocation} />} />
          <Route path="/crm/deals" element={<CRM selectedLocation={selectedLocation} />} />
          <Route path="/crm/deals/:id" element={<DealProfilePage selectedLocation={selectedLocation} />} />
          <Route path="/crm" element={<CRM selectedLocation={selectedLocation} />} />
          <Route path="/auth/callback" element={<SimpleGmailCallback />} />
          <Route path="/offices" element={<OfficeManagement selectedLocation={selectedLocation} userRole={user?.role} />} />
          <Route path="/offices/:id" element={<OfficeProfilePage selectedLocation={selectedLocation} userRole={user?.role} />} />
          <Route path="/members" element={<MemberDirectory selectedLocation={selectedLocation} />} />
          <Route path="/members/:id" element={<MemberProfilePage selectedLocation={selectedLocation} />} />
          <Route path="/tasks" element={<TaskManagement selectedLocation={selectedLocation} />} />
          <Route path="/templates" element={<MarketingTemplates selectedLocation={selectedLocation} />} />
          <Route path="/resources" element={<EmployeeResources selectedLocation={selectedLocation} />} />
          <Route path="/reporting" element={<OccupancyReporting selectedLocation={selectedLocation} />} />
          <Route path="/term-analysis" element={<TermRateReporting selectedLocation={selectedLocation} />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={
              <ProtectedRoute>
                <AuthenticatedApp />
              </ProtectedRoute>
            } />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;